import React from 'react'
import { TileLayer } from 'react-leaflet/TileLayer'

const MapTileLayer: React.FC = () => (
  <TileLayer
    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>'
    url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
    subdomains='abcd'
    maxZoom={20}
  />
)

export default MapTileLayer
